import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Utr, Description } from '../../text';

const LocalPlayerCard = props => {
    const {
        player,
        utrType,
        'data-testid': dataTestId,
    } = props;

    const {
        id,
        firstName,
        lastName,
        location,
        ratingStatusSingles,
        descriptionShort,
    } = player;

    let description = '';
    if (descriptionShort) {
        description = [descriptionShort];
    } else {
        description = location && location.display ? [location.display] : [];
    }

    return (
        <Link to={`/players/${id}`} data-testid={dataTestId && `${dataTestId}.card-link`}>
            <div className="utr-card player-card">
                <div className="card-view">
                    <div className="row">
                        <div className={`value utr ${ratingStatusSingles !== 'Rated' ? 'text-lighter' : ''}`}>
                            <Utr player={player} force={{ utrType, verifiedIcon: true }} data-testid={dataTestId && `${dataTestId}.utr`} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="name-and-place show-ellipsis">
                            <div className="name h6 show-ellipsis">
                                <div data-testid={dataTestId && `${dataTestId}.first-name`}>{firstName}</div>
                                <div data-testid={dataTestId && `${dataTestId}.last-name`}>{lastName}</div>
                            </div>
                            <div className="place show-ellipsis">
                                <Description desc={description} data-testid={dataTestId && `${dataTestId}.place`} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    );
};

LocalPlayerCard.propTypes = {
    'data-testid': PropTypes.string,
};

LocalPlayerCard.defaultProps = {
    'data-testid': null,
};

export default LocalPlayerCard;
